import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalLoadingService {
  private _loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this._loadingSubject.asObservable();

  show(): void {
    this._loadingSubject.next(true);
  }

  hide(): void {
    this._loadingSubject.next(false);
  }
}
